export const CHART_COLORS = ['#6F4FF2', '#1FBDB8'];
